import { defineComponent as _defineComponent } from 'vue'
import {
  useSyncEuTaxonomyActivitiesWithQuestionnaireMutation,
  type AccountType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Assignment',
  props: {
  account: {
    type: Object as () => AccountType,
    required: true,
  },
},
  setup(__props) {



const { mutate: syncEuTaxonomyActivities, loading: syncLoading } =
  useSyncEuTaxonomyActivitiesWithQuestionnaireMutation()

return { __sfc: true,syncEuTaxonomyActivities, syncLoading }
}

})